var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 0V6.41667H2.75C1.24208 6.41667 0 7.65875 0 9.16667V18.3333H4.58333V22H17.4167V18.3333H22V9.16667C22 7.65875 20.7579 6.41667 19.25 6.41667H17.4167V0H4.58333ZM6.41667 1.83333H15.5833V6.41667H6.41667V1.83333ZM2.75 8.25H19.25C19.7688 8.25 20.1667 8.64783 20.1667 9.16667V16.5H17.4167V12.8333H4.58333V16.5H1.83333V9.16667C1.83333 8.64783 2.23117 8.25 2.75 8.25ZM3.66667 9.16667C3.1625 9.16667 2.75 9.57917 2.75 10.0833C2.75 10.5875 3.1625 11 3.66667 11C4.17083 11 4.58333 10.5875 4.58333 10.0833C4.58333 9.57917 4.17083 9.16667 3.66667 9.16667ZM6.41667 14.6667H15.5833V20.1667H6.41667V14.6667Z",
    fill: "#BCC5D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.0454151fe3453c94febc227e7498c639.svg";
export { ForwardRef as ReactComponent };